import * as Models from "../../ts/rlAdmin.models";
import * as Utils from "../../ts/rlAdmin.utils";

import { NotifyService } from "../../services/notify-service";
import { EntityConfigService } from "../../services/entity-config-service";
import { LocalCacheService } from "../../services/local-cache-service";


export class HierarchyController {

    static $inject = ["$scope", "$window", "$q", "$timeout", "notifyService", "entityConfigService", "localCacheService"];

    charValueSetID: string;
    charValueSourceID: string;
    charValueSourceLabel: string;
    charValueSource: Models.ICharacteristicValueSource;
    charValueSet: Models.ICharacteristicValueSet;
    charValueIDValueGroupAssocs: { [key: string]: string[] };
    initialized: boolean;

    listValues: Models.ICharacteristicValue[];
    listValuesSorted: Models.ICharacteristicValue[];
    dupeListValueIDs: number[];

    editListValue: Models.ICharacteristicValue;

    listRels: Models.ICharacteristicValueHierarchy[];
    nodes: Models.IGraphNode<Models.ICharacteristicValue>[];
    nodeDescendantCounts: { [key: string]: number };

    newListValue: string;

    addModeNode: Models.IGraphNode<Models.ICharacteristicValue>;

    flatList: boolean;

    editValueModalOpen: boolean;
    editNode: Models.IGraphNode<Models.ICharacteristicValue>;
    editValue: Models.ICharacteristicValue;

	editValueVisible: boolean;

	showConfirmAlphabetizationModal: boolean;

    dupeValueModalOpen: boolean;

    isDirty: boolean;

    validateModalLabel: (value: any) => { name: string; valid: boolean };
    validateNewList: (value: any) => { name: string; valid: boolean };
    validateEditList: (value: any) => { name: string; valid: boolean };

    assocValueGroupModalOpen: boolean;
    assocValueGroupHierarchyID: string;
    otherCharValueSources: Models.ICharacteristicValueSource[];
    otherCharValueGroups: Models.ICharacteristicValueGroup[];
    selectedOtherCharValueSource: Models.ICharacteristicValueSource;
    selectedOtherCharValueGroupsIDs: string[];
    charValueIDs: number[];
    showJobProgressStatus: boolean;
    jobId: string;
    jobTitle: string;

    maxLength = 500;
    offset = 0;
    rangeOffset = 0;

    get rangeMessage() {
		return `Showing ${Math.min(this.rangeOffset + 1, this.nodes.length - this.maxLength)} - ${Math.min(this.rangeOffset + this.maxLength, this.nodes.length)} of ${this.nodes.length}`;
	}

    constructor(private $scope: ng.IScope, private $window: ng.IWindowService, private $q: ng.IQService, private $timeout: ng.ITimeoutService, private notifyService: NotifyService, private entityConfigService: EntityConfigService, private localCacheService: LocalCacheService) {

        this.charValueSetID = "";
        this.charValueSourceID = "";
        this.charValueSource = null;
        this.charValueSet = null;
        this.charValueIDValueGroupAssocs = {};
        this.initialized = false;

        this.listValues = [];
        this.listValuesSorted = [];
        this.dupeListValueIDs = [];
        this.editListValue = null;
        this.listRels = [];
        this.nodes = [];
        this.nodeDescendantCounts = {};

        this.newListValue = "";
        this.addModeNode = null;
        this.flatList = false;
        this.editValueModalOpen = false;
        this.editNode = null;
        this.editValue = null;
        this.editValueVisible = false;
        this.isDirty = false;

        this.assocValueGroupModalOpen = false;
        this.assocValueGroupHierarchyID = null;
        this.otherCharValueSources = [];
        this.otherCharValueGroups = [];
        this.selectedOtherCharValueSource = null;
        this.selectedOtherCharValueGroupsIDs = [];
        this.charValueIDs = [];
        this.showJobProgressStatus = false;
        this.jobId = "";
        this.jobTitle = "";
        // rebuild sorted list when listValues change
        $scope.$watch(() => this.listValues, (newValue, oldValue) => {
            this.listValuesSorted = _.sortBy(newValue, (listValue) => listValue.charValueLabel.toLowerCase());
            if (JSON.stringify(newValue) != JSON.stringify(oldValue)) {
                this.SetDirty(true);
            }
        }, true);

        $scope.$watch(() => this.charValueIDValueGroupAssocs,
            (newValue, oldValue) => {
                if (newValue != oldValue) {
                    this.SetDirty(true);
                }
            }, true);

        // rebuild dupeListvalueIDs when list rels change
        $scope.$watch(() => this.listRels, (newValue, oldValue) => {
            this.dupeListValueIDs = _(newValue)
                .groupBy(lv => lv.charValueID)
                .pairs()
                .filter((kvp: [string, Models.ICharacteristicValueHierarchy[]]) => kvp[1].length > 1)
                .map((kvp: [string, Models.ICharacteristicValueHierarchy[]]) => _.parseInt(kvp[0]))
                .valueOf();
        }, true);

        // rebuild list rels when node graph changes
        $scope.$watch(() => this.nodes,
            (newValue, oldValue) => {
                this.nodeDescendantCounts = {};
                this.listRels = this.BuildRels(newValue);
            }, true);

        // if flat list is selected, set addModeNode to null (adds only to root)
        $scope.$watch(() => this.flatList,
            (newValue, oldValue) => {
                this.addModeNode = null;
            });

        // reset edit Value when edit modal closes
        $scope.$watch(() => this.editValueModalOpen,
            (newValue, oldValue) => {
                if (oldValue && !newValue) {
                    this.editNode = null;
                    this.editValue = null;
                }
            });

        // hacky way to bind a checkbox to a numeric value
        $scope.$watch(() => this.editValueVisible,
            (newValue, oldValue) => {
                if (this.editValue != null) {
                    this.editValue.statusID = newValue ? 1 : 0;
                }
            });

        $scope.$watch(() => this.assocValueGroupModalOpen,
            (newValue, oldValue) => {
                if (!newValue && oldValue) {
                    this.assocValueGroupHierarchyID = null;
                    this.selectedOtherCharValueSource = null;
                    this.otherCharValueGroups = [];
                    this.selectedOtherCharValueGroupsIDs = [];
                }
            });

        $scope.$watch(() => this.selectedOtherCharValueSource,
            (newValue, oldValue) => {
                if (newValue != oldValue && !_.isEmpty(newValue)) {
                    this.notifyService.startProgress();
                    entityConfigService.getCharValueGroupList(newValue.charValueSourceID)
                        .then((results) => {
                            this.otherCharValueGroups = results;
                        }).finally(() => {
                            this.notifyService.endProgress();
                        });
                }
            });

        this.validateModalLabel = (value: string) => {
            var valid = true;
            if (this.editValue != null) {
                var dupeValue = _.find(this.listValues, (lv) => lv.charValueID != this.editValue.charValueID && lv.charValueLabel.trim().toLowerCase() == value.trim().toLowerCase());
                valid = dupeValue == null;
            }
            return {
                name: "uniqueValue",
                valid: valid
            };
        };

        this.validateNewList = (value: string) => {
            var dupe = _.find(this.listValues, (lv) => lv.charValueLabel.trim().toLowerCase() == value.trim().toLowerCase());
            return {
                name: "uniqueValue",
                valid: dupe == null
            };
        };

        this.validateEditList = (value: string) => {
            var valid = true;
            if (this.editListValue != null) {
                var dupeValue = _.find(this.listValues, (lv) => lv.charValueID != this.editListValue.charValueID && lv.charValueLabel.trim().toLowerCase() == value.trim().toLowerCase());
                valid = dupeValue == null;
            }
            return {
                name: "uniqueValue",
                valid: valid
            };
        };
    }

    Init(charValueSourceID: string, charValueSetID: string, charValueSourceLabel: string, flatList: any = false) {

        this.charValueSourceID = charValueSourceID;
        this.charValueSetID = charValueSetID;
        this.charValueSourceLabel = charValueSourceLabel;
        this.flatList = flatList || false;

        this.RefreshList();
    }

    SetDirty(flag: boolean) {
        this.isDirty = flag;
    }

    RefreshList() {
        this.notifyService.startProgress();

        // load value set
        var promise1 = this.entityConfigService.getCharacteristicValueSet(this.charValueSetID)
            .then((result) => {
                this.charValueSet = result;
            });

        // load value list
        var promise2 = this.entityConfigService.getCharacteristicValueList(this.charValueSetID)
            .then((results) => {
                this.listValues = results;
            });

        // load hierarchy list
        var promise3 = this.entityConfigService.getCharacteristicValueHierarchyList(this.charValueSourceID)
            .then((results) => {
                this.listRels = results;
            });

        // load value source
        var promise4 = this.entityConfigService.getCharacteristicValueSource(this.charValueSourceID)
            .then((result) => {
                this.charValueSource = result;
            });

        var promise5 = this.entityConfigService.getCharValueHierarchyValueGroupAssocList(this.charValueSourceID)
            .then((result) => {
                this.charValueIDValueGroupAssocs = {};

                _(result)
                    .groupBy((assoc) => assoc.charValueHierarchyID)
                    .forOwn((value: Models.ICharacteristicValueHierarchyValueGroupAssociation[], key: string) => {
                        this.charValueIDValueGroupAssocs[key] = value.map(assoc2 => assoc2.charValueGroupID);
                    }).value();
            });

        var promise6 = this.entityConfigService.getCharacteristicValueSourceList()
            .then((result) => {
                this.otherCharValueSources = result.filter(src => src.charValueSourceID != this.charValueSourceID);
            });

        return this.$q.all([promise1, promise2, promise3, promise4, promise5, promise6])
            .then(() => {
                this.nodes = this.BuildGraph();
                this.initialized = true;

                this.$timeout(() => {
                    this.isDirty = false;
                });

            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    BuildGraph() {
        var output: Models.IGraphNode<Models.ICharacteristicValue>[] = [];
        var stack: Models.IKeyValuePair<Models.ICharacteristicValueHierarchy, Models.IGraphNode<Models.ICharacteristicValue>>[] = [];

        var listDict: _.Dictionary<Models.ICharacteristicValue> = _.transform(this.listValues, (acc, listValue) => { acc[listValue.charValueID] = listValue; return acc; }, {});

        var rels = _.sortBy(this.listRels, (rel) => rel.minPos);
        _.forEach(rels, (listRel) => {

            var listValue = listDict[listRel.charValueID];
            var node = new Models.GraphNode<Models.ICharacteristicValue>(listValue);
            node.uniq = listRel.charValueHierarchyID;

            var kvp = _.last(stack) || { key: null, value: null };
            var lastRel = kvp.key;
            var lastNode = kvp.value;

            // find a parent on the stack who's minPos/maxPos contain yours
            while (lastNode != null && lastRel != null && (listRel.minPos < lastRel.minPos || listRel.maxPos > lastRel.maxPos)) {
                kvp = stack.pop();
                // if you cleared out the stack, you're a root level
                if (kvp != null) {
                    lastRel = kvp.key;
                    lastNode = kvp.value;
                } else {
                    lastRel = null;
                    lastNode = null;
                }
            }

            // null lastNode/lastRel makes you a root node
            if (lastNode == null && lastRel == null) {
                output.push(node);  // send to output as root node
                stack.push({ key: listRel, value: node });   // join parent stack
                return;           // next
            } else {
                // restack the last popped node
                stack.push({ key: lastRel, value: lastNode });
            }

            // add childnode to parent node
            lastNode.childNodes.push(node);
            if (listRel.minPos + 1 == listRel.maxPos) {
                // just a leaf node, add child and continue;
                return;
            } else {
                // this rel has child rels, push to parent stack and continue;
                stack.push({ key: listRel, value: node });
                return;
            }
        });
        return output;
    }

	BuildRels(nodes: Models.IGraphNode<Models.ICharacteristicValue>[], alphabetize: boolean = false) {

        var output: Models.ICharacteristicValueHierarchy[] = [];
        var minPos = 1;

        var walk = (node: Models.IGraphNode<Models.ICharacteristicValue>, parentValueID: number = 0, level: number = 1): Models.ICharacteristicValueHierarchy => {

            // create Rel, assume a leaf with minPos + 1 == maxPos until measured otherwise
            var rel: Models.ICharacteristicValueHierarchy = {
                charValueHierarchyID: node.uniq,
                charValueID: node.item.charValueID,
                charValueSourceID: this.charValueSource.charValueSourceID,
                childCount: node.childNodes.length,
                parentCharValueID: parentValueID,
                divID: this.charValueSet.divID,
                level: level,
                minPos: minPos,
                maxPos: minPos + 1
            };

            // incr minPos for next sibling/child
            minPos++;

            // push to external output list;
            output.push(rel);

			if (alphabetize) {
				node.childNodes = _.sortBy(node.childNodes, node => node.item.charValueLabel.toLowerCase());				 
			}
			
            // foreach child node
			for (var i = 0; i < node.childNodes.length; i++) {				
                var childRel = walk(node.childNodes[i], node.item.charValueID, level + 1);
                // make current rel maxPost larger than child maxPos
                rel.maxPos = childRel.maxPos + 1;
            }

            // get minPos ready for new sibling
            minPos = rel.maxPos + 1;

            var descendantCount = (rel.maxPos - rel.minPos - 1) / 2;
            this.nodeDescendantCounts[node.uniq] = descendantCount;

            // return rel for evaluation by recursive caller
            return rel;
        };

		if (alphabetize) {
			let sortedNodes = _.sortBy(nodes, node => node.item.charValueLabel.toLowerCase());
			nodes = sortedNodes;
		}
        for (var i = 0; i < nodes.length; i++) {
            walk(nodes[i]);
        }
        return output;
    }

    AddNewListValue() {
        var maxIDListValue = _.min(this.listValues, (listValue) => listValue.charValueID);
        var id = -1;
        if (maxIDListValue != null) {
            id = maxIDListValue.charValueID - 1;
        }

        this.listValues.push({
            charValueDescription: this.newListValue,
            charValueID: id,
            charValueLabel: this.newListValue,
            charValueSetID: this.charValueSet.charValueSetID,
            divID: this.charValueSet.divID,
            statusID: 1,
            xref: ""
        });
        this.SetDirty(true);
        this.newListValue = "";
    }

    FindParentNode(node: Models.IGraphNode<Models.ICharacteristicValue>) {

        var output: Models.IGraphNode<Models.ICharacteristicValue> = null;

        _.foreachGraph(this.nodes, (n1) => n1.childNodes, (n2) => {
            var found = _.find(n2.childNodes, (n3) => n3 == node);
            if (found != null) {
                output = n2;
            }
        });

        return output;
    }

    FindOrCreateListValue(value: string) {
        var output = _.find(this.listValues, lv => lv.charValueLabel.toLowerCase() == value.toLowerCase());
        if (output == null) {
            // get the next lowest negative value (negative means create new)
            var maxId = -1;
            var maxIdValue = _.min(this.listValues, (lv) => lv.charValueID);
            if (maxIdValue != null && <any>maxIdValue != Infinity && maxIdValue.charValueID < 0) {
                maxId = maxIdValue.charValueID - 1;
            }

            output = {
                charValueDescription: value,
                charValueID: maxId,
                charValueLabel: value,
                charValueSetID: this.charValueSet.charValueSetID,
                divID: this.charValueSet.divID,
                statusID: 1,
                xref: ""
            };
            this.listValues.push(output);
            this.SetDirty(true);
        }
        return output;
    }

    EditNode(node: Models.IGraphNode<Models.ICharacteristicValue>) {
        this.editNode = node;
        this.editValue = _.clone(node.item);
        this.editValueVisible = this.editValue.statusID == 1;
        this.editValueModalOpen = true;
    }

    GroupAssocNode(node: Models.IGraphNode<Models.ICharacteristicValue>) {
        this.assocValueGroupHierarchyID = node.uniq;

        this.selectedOtherCharValueSource = null;
        this.selectedOtherCharValueGroupsIDs = _.cloneDeep(this.charValueIDValueGroupAssocs[this.assocValueGroupHierarchyID]) || [];
        if (this.selectedOtherCharValueGroupsIDs.length > 0) {
            this.entityConfigService.getCharValueGroup(this.selectedOtherCharValueGroupsIDs[0])
                .then((result) => {
                    this.selectedOtherCharValueSource = _.find(this.otherCharValueSources, src => src.charValueSourceID == result.charValueSourceID);
                    this.assocValueGroupModalOpen = true;
                });
        } else {
            this.assocValueGroupModalOpen = true;
        }
    }

    AcceptGroupAssocs() {
        this.charValueIDValueGroupAssocs[this.assocValueGroupHierarchyID] = this.selectedOtherCharValueGroupsIDs;
        this.assocValueGroupModalOpen = false;
    }

    GetAllParents(node: Models.IGraphNode<Models.ICharacteristicValue>) {
        let parentNodes = [node];
        let parentNode = node;
        while ((parentNode = this.FindParentNode(parentNode)) !== null) {
            parentNodes.push(parentNode);
        }
        return parentNodes;
    }

    GetAllChildren(node: Models.IGraphNode<Models.ICharacteristicValue>) {
        let children = [];
        // If the node is null, that means a new object is being created at the top level
        if (node) {
            let curNode = node;
            _.forEach(node.childNodes,
                (childNode) => {
                    children.push(childNode);
                    children.concat(this.GetAllChildren(childNode));
                });
        }
        return children;
    }

    ConfirmValidity(node: Models.IGraphNode<Models.ICharacteristicValue>, parent: Models.IGraphNode<Models.ICharacteristicValue>) {
        // This checks for a top level node
        var parentNode = this.FindParentNode(node);
        // If no parent, the object being modified/added/moved is a top level node
        if (parentNode == null) {
            let childNodes = this.GetAllChildren(parent);
            // If no parents or children, check the listValues to make sure there's no duplicates
            if (!childNodes && !_.find(this.listValues, (lv) => lv.charValueLabel === node.item.charValueLabel)) {
                return true;
            }
            // Checks the other top level nodes to check against duplication
            else if (!_.any(this.nodes, testnode => testnode.item.charValueLabel === node.item.charValueLabel)
                // Checks child nodes to check against duplication
                && !_.any(this.GetAllChildren(parent), children => children.item.charValueLabel === node.item.charValueLabel)) {
                return true;
            }
        }
        // In this case, there is a parent node
        else if (parentNode !== null &&
            // Checks all nodes above the current in the hierarchy to prevent duplicates
            !_.any(this.GetAllParents(node),
                parent => parent.item.charValueLabel === node.item.charValueLabel) &&
            // Checks the children as well
            !_.any(this.GetAllChildren(parentNode),
                children => children.item.charValueLabel === node.item.charValueLabel)) {
            return true;
        }
        return false;
    }

    FlattenNodes(nodes: Models.IGraphNode<Models.ICharacteristicValue>[]) {
        const stack = nodes.slice(0);
        const res = [];
        while (stack.length) {
            // pop value from stack
            const next = stack.pop();
            if ((next.childNodes.length > 0)) {
                // push back array items, won't modify the original input
                stack.push(...next.childNodes);
            }
            res.push(next.item);

        }
        //reverse to restore input order
        return res.reverse();

        // Checks child nodes to check against duplication

    }
    ConfirmAdd(newValue: string, nodes: Models.IGraphNode<Models.ICharacteristicValue>[], level: Number, parentNode: Models.IGraphNode<Models.ICharacteristicValue>): boolean {

        var flattenedNodes = this.FlattenNodes(this.nodes);
        if (_.any(flattenedNodes, node => node.charValueLabel.trim().toLowerCase() === newValue.trim().toLowerCase())) {
            return true;
        }
        return false;
    }

    ConfirmMove(node: Models.IGraphNode<Models.ICharacteristicValue>,
        moveTo: Models.IGraphNode<Models.ICharacteristicValue>) {
        if (!_.any(this.GetAllChildren(moveTo),
            children => children.item.charValueLabel.toLowerCase() === node.item.charValueLabel.toLowerCase()) &&
            moveTo.item.charValueLabel.toLowerCase() !== node.item.charValueLabel.toLowerCase())
            {
                return true;
            }
            return false;
    }

    IsValid() {
        if (this.newListValue.length === 0 || _.find(this.listValues, (lv) => lv.charValueLabel.trim().toLowerCase() === this.newListValue.trim().toLowerCase()) || !this.newListValue.trim()) {
            return false;
        }
        return true;
    }

    IsValidEdit() {
        if (this.editValue != null) {
            if (this.editValue.charValueLabel == undefined || _.find(this.listValues, (lv) => this.editValue && lv.charValueLabel.trim().toLowerCase() === this.editValue.charValueLabel.trim().toLowerCase())  || this.editValue.charValueLabel.length === 0) {
                return false;
            }
        }
        
        return true;
    }

    AcceptEdit() {
        var parentNode = this.FindParentNode(this.editNode);
        // Top Level node being modified
        if (parentNode == null && !_.any(this.nodes, node => node.item.charValueLabel === this.editValue.charValueLabel) && !_.any(this.GetAllChildren(this.editNode), children => children.item.charValueLabel === this.editValue.charValueLabel)) {
            // If no duplicates found in the Value Set, assign the editValue (node) to editNode.item
            _.assign(this.editNode.item, this.editValue);
            if (!_.any(this.charValueIDs, id => id == this.editValue.charValueID)) {
                this.charValueIDs.push(this.editValue.charValueID);
            }
        }
        else if (parentNode != null && !_.any(this.GetAllParents(this.editNode), parent => parent.item.charValueLabel == this.editValue.charValueLabel) && !_.any(this.GetAllChildren(parentNode), children => children.item.charValueLabel === this.editValue.charValueLabel)) {
            _.assign(this.editNode.item, this.editValue);
            if (!_.any(this.charValueIDs, id => id == this.editValue.charValueID)) { 
                this.charValueIDs.push(this.editValue.charValueID);
            }
        }
        this.editValueModalOpen = false;
    }

    SaveHierarchy() {
        var jobResponse: Models.IJobResponse = null;
        this.notifyService.startProgress();
        this.entityConfigService.updateCharValueSourceHierarchy(this.charValueSource.charValueSourceID, this.listRels, this.listValues, this.charValueIDValueGroupAssocs, this.charValueIDs)
            .then((result) => {
                this.charValueIDs = [];
                var key = `getCharLovMetaData_${this.charValueSource.charValueSourceID}`;
                this.localCacheService.removeItem(key);
                this.notifyService.notifySuccess("Hierarchy Updated");
                jobResponse = result;
                return this.RefreshList();
            }, () => {
                this.notifyService.notifyError("Error updating Hierarchy");
            })
            .finally(() => {
                this.notifyService.endProgress();
                if (!Utils.GuidUtil.IsEmpty(jobResponse.jobID)) {
                    this.showJobProgressStatus = true;
                    this.jobId = jobResponse.jobID;
                    this.jobTitle = jobResponse.jobTitle;
                }
            });
    }

    EditListValue(listValue: Models.ICharacteristicValue) {
        this.editListValue = _.clone(listValue);
    }

    CancelEditListValue() {
        this.editListValue = null;
    }

    SaveEditListValue() {
        var oldValue = _.find(this.listValues, (lv) => lv.charValueID == this.editListValue.charValueID);
        if (oldValue != null) {
            oldValue.charValueLabel = this.editListValue.charValueLabel;
            if (!_.any(this.charValueIDs, id => id == this.editListValue.charValueID)) {
                this.charValueIDs.push(this.editListValue.charValueID);
            }
            this.SetDirty(true);
        }
        this.editListValue = null;
    }

    GetCharValSrcCharacteristicCount(node: Models.IGraphNode<Models.ICharacteristicValue>) {
        return this.entityConfigService.getCharacteristicValueSourceCharacteristicCount(this.charValueSourceID, node.item.charValueID);
    }

    OffsetChanged() {
		this.$timeout(() => {
			this.offset = this.rangeOffset;
		}, 500);
	}

	//LOV Alphabetizing
	//Open up confimation modal
	ConfirmAlphabetization() {
		this.showConfirmAlphabetizationModal = true;
	}
	AlphabetizeHierarchy() {		
		this.showConfirmAlphabetizationModal = false;
		this.listRels = this.BuildRels(this.nodes, true);
		this.SaveHierarchy();
	}
}